export const ownsCurrentFollowerCommandGeneration = ({
  followerCoordinated,
  requestGeneration,
  currentGeneration,
} = {}) => {
  if (followerCoordinated !== true) return true;
  return Number.isSafeInteger(requestGeneration)
    && Number.isSafeInteger(currentGeneration)
    && requestGeneration === currentGeneration;
};

const FOLLOWER_RETRY_DELAYS_MS = Object.freeze([100, 250, 500, 1000, 2000, 4000]);

export const nextFollowerRetryDelayMs = attempt => {
  const safeAttempt = Number.isSafeInteger(attempt) && attempt > 0 ? attempt : 1;
  return FOLLOWER_RETRY_DELAYS_MS[safeAttempt - 1] ?? null;
};